<template>
  <div>
    <div class="intro-banner text-white text-xl">
      <p v-if="aiType === 'letter'">{{ $t('AiHome.letter.Letter_Information') }}</p>
      <p v-if="aiType === 'speech'">{{ $t('AiHome.speech.Speech_Information') }}</p>
    </div>
    <div class="intro-text bg-white p-4 text-lg">
      <h6 class="mb-1 font-bold text-lg">{{ $t('AiHome.rule.Total_Points') }}：<span>{{ Number(remainPoints) }}</span> {{ $t('AiHome.rule.point') }}
        <a @click="swal_remainPoints" class="pointer"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.<path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/></svg></a>
      </h6>
      <h6 class="font-bold text-lg">{{ aiType === 'letter' ? $t('AiHome.rule.letter') : $t('AiHome.rule.speech') }}{{ $t('AiHome.common.deduct_points') }}<span>20</span> {{ $t('AiHome.rule.point') }}</h6>
      <form class="font-semibold" v-if="aiType === 'letter'">
        <div class="form-group">
          <label for="disabledTextInput">{{ $t('AiHome.letter.Sender_Name') }}</label>
          <input type="text" id="disabledTextInput" class="form-control" placeholder="" disabled v-model="s_name">
        </div>
        <div class="form-group">
          <label for="disabledTextInput">{{ $t('AiHome.letter.Sender_Company') }}</label>
          <input type="text" id="disabledTextInput" class="form-control" placeholder="" disabled v-model="s_itentity">
        </div>
        <div class="form-group">
          <label for="disabledTextInput">{{ $t('AiHome.letter.Recipient_Name') }}</label>
          <input type="text" id="disabledTextInput" class="form-control" placeholder="" disabled v-model="r_name">
        </div>
        <div class="form-group">
          <label for="disabledTextInput">{{ $t('AiHome.letter.Recipient_Company') }}</label>
          <input type="text" id="disabledTextInput" class="form-control" placeholder="" disabled v-model="r_itentity">
        </div>
        <div class="form-group">
          <label for="disabledTextInput">{{ $t('AiHome.letter.Subject') }}</label>
          <input type="text" id="disabledTextInput" class="form-control" placeholder="" disabled v-model="purpose">
        </div>
        <div class="form-group">
          <label for="disabledTextInput">{{ $t('AiHome.letter.Summary') }}</label>
          <textarea v-model="content" class="form-control" id="emailTitle" rows="3" :placeholder="$t('AiHome.common.ph_disabled_summary')" disabled></textarea>
        </div>
        <a class="btn-submit mx-2 d-inline-block pointer" @click="swal_startCheck">{{ $t('AiHome.common.edit_letter_info') }}</a>
      </form>
      <form class="font-semibold" v-if="aiType === 'speech'">
        <div class="form-group">
          <label for="disabledTextInput">{{ $t('AiHome.speech.Topic') }}</label>
          <input type="text" id="disabledTextInput" class="form-control" placeholder="" disabled v-model="topic">
        </div>
        <div class="form-group">
          <label for="disabledTextInput">{{ $t('AiHome.speech.Audience') }}</label>
          <input type="text" id="disabledTextInput" class="form-control" placeholder="" disabled v-model="audience">
        </div>
        <div class="form-group">
          <label for="disabledTextInput">{{ $t('AiHome.speech.Type') }}</label>
          <input type="text" id="disabledTextInput" class="form-control" placeholder="" disabled v-model="genre">
        </div>
        <div class="form-group">
          <label for="disabledTextInput">{{ $t('AiHome.speech.Occasion') }}</label>
          <input type="text" id="disabledTextInput" class="form-control" placeholder="" disabled v-model="setting">
        </div>
        <div class="form-group">
          <label for="disabledTextInput">{{ $t('AiHome.speech.Summary') }}</label>
          <textarea v-model="content" class="form-control" id="emailTitle" rows="3" :placeholder="$t('AiHome.common.ph_disabled_summary')" disabled></textarea>
        </div>
        <a class="btn-submit mx-2 d-inline-block pointer" @click="swal_startCheck">
          <span v-if="aiType === 'letter'">{{ $t('AiHome.common.edit_letter_info') }}</span>
          <span v-if="aiType === 'speech'">{{ $t('AiHome.common.edit_speech_info') }}</span></a>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'inputData',
  props: {
    aiType: {
      type: String,
      default: null
    },
    r_name: {
      type: String,
      default: null
    },
    r_itentity: {
      type: String,
      default: null
    },
    s_name: {
      type: String,
      default: null
    },
    s_itentity: {
      type: String,
      default: null
    },
    purpose: {
      type: String,
      default: null
    },

    type: {
      type: String,
      default: null
    },
    topic: {
      type: String,
      default: null
    },
    audience: {
      type: String,
      default: null
    },

    content: {
      type: String,
      default: null
    },
    genre: {
      type: String,
      default: null
    },
    setting: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters([
      'remainPoints'
    ])
  },
  mounted () {
  },
  methods: {
    editData () {
      this.$emit('editData')
    },
    swal_remainPoints () {
      let self = this
      self.$swal({
        html: `<h6>${self.$t('AiHome.swal.current_points')}<span class="text-red-main-ai">${self.remainPoints}</span> ${self.$t('AiHome.rule.point')}</h6>
               <p>${self.$t('AiHome.swal.points_desc')}</p>
               <ul>
                 <li>${self.$t('AiHome.swal.speaking_practice')}</li>
                 <li>${self.$t('AiHome.swal.business_letter')}</li>
                 <li>${self.$t('AiHome.swal.speech_script')}</li>
               </ul>`,
        showCloseButton: false,
        focusConfirm: false,
        confirmButtonText: self.$t('AiHome.swal.got_it'),
        title: self.$t('AiHome.swal.rules_title'),
        customClass: {
          title: 'text-white',
          container: 'text-center',
          popup: 'p-0',
          header: 'swal-header-notice justify-content-center align-items-center',
          closeButton: '',
          htmlContainer: 'remainPoints_swal my-3',
          actions: 'mb-4 mt-2',
          confirmButton: 'btn-submit',
          cancelButton: 'bg-red-main-ai',
        }
      }).then((result) => {
        if (result.isConfirmed) {
          self.postData()
        }
      }
      )
    },
    swal_startCheck () {
      let self = this
      let typeText = self.$t('AiHome.rule.letter')
      self.aiType === 'speech' ? typeText = self.$t('AiHome.rule.speech') : null
      self.$swal({
        html: `<p>${self.$t('AiHome.swal.confirm_modify', { type: typeText })}</p>`,
        showDenyButton: true,
        focusConfirm: false,
        confirmButtonText: self.$t('AiHome.common.confirm'),
        denyButtonText: self.$t('AiHome.swal.stay_on_page'),
        title: self.$t('AiHome.rule.Friendly_Reminder'),
        customClass: {
          title: 'text-white',
          container: '',
          popup: 'p-0',
          header: 'swal-header-notice justify-content-center align-items-center',
          closeButton: '',
          htmlContainer: 'swal_check my-4',
          actions: 'mb-4 mt-2',
          confirmButton: 'btn-submit',
          cancelButton: 'bg-red-main-ai',
          denyButton: 'denyButton-ai order_1'
        }
      })
        .then((result) => {
          if (result.isConfirmed === true) {
            self.editData()
          }
        }
      )
    }
  }
}
</script>
<style lang="scss" scoped>
  .intro-banner {
    padding-top: 5rem;
    padding-bottom: 5rem;
    background: #0E103E;
    text-align: center;
    font-weight: 700;
    background-image:
      url('~@/assets/image/ai/plusSS.png'), url('~@/assets/image/ai/plusSS.png'),
      url('~@/assets/image/ai/plusS.png'), url('~@/assets/image/ai/plusS.png'),
      url('~@/assets/image/ai/plusB.png'), url('~@/assets/image/ai/plusB.png'),
      url('~@/assets/image/ai/robotL.png'), url('~@/assets/image/ai/robotR.png');
    background-repeat: no-repeat;
    background-position:
      left 18% top 15%, right 18% top 15%,
      left 6% top 30%, right 6% top 30%,
      left 13% top 55%, right 13% top 55%,
      left 10% bottom 0%, right 5% bottom 0%;
    p {
      margin: 0;
    }
    @media (max-width: 1024px) {
      font-size: 1.125rem;
    }
  }
  .intro-text{
    svg {
      width: 1em;
    }
    h6 {
      span {
        color: #F30000;
      }
      @media (max-width: 1024px) {
        font-size: 1rem;
      }
    }
    p {
      margin-bottom: 1.25rem;
      line-height: 150%;
      font-weight: 500;
      @media (max-width: 1024px) {
        font-size: 1rem;
      }
    }
    .title {
      font-weight: 700;
    }
    .icon-img {
      max-width: 1.5em;
      height: auto;
      object-fit: contain;
    }
  }
</style>
